<template>
    <div class="message-actions">
        <div class="date">{{message.date.full}}</div>
        <div class="actions">
            <ActionButton v-if="message.recipients.count === 1"
                @click="onActionClick('reply')"
                icon='fas fa-reply'
                class='clear'
                text='messages.open.reply'
            />
            <ActionButton v-if="message.recipients.count > 1"
                @click="onActionClick('reply_all')"
                icon='fas fa-reply-all' class='clear'
                text='messages.open.reply_all'
            />
            <DropdownList class="more-actions align-right">
                <template #select>
                    <ActionButton
                        v-tooltip='"messages.actions.more"'
                        icon='fas fa-ellipsis-v'
                        class='clear'
                    />
                </template>

                <template #options>
                    <ActionButton
                        @click="onActionClick('reply')"
                        icon='fas fa-reply'
                        class="clear"
                        text='messages.open.reply'
                    />
                    <ActionButton v-if="message.recipients.count > 1"
                        @click="onActionClick('reply_all')"
                        icon='fas fa-reply-all'
                        class="clear"
                        text='messages.open.reply_all'
                      />
                    <ActionButton
                        @click="onActionClick('forward')"
                        icon='fas fa-share'
                        class="clear"
                        text="messages.open.forward"
                      />
                    <ActionButton
                        @click="onActionClick('forward_attachment')"
                        icon=''
                        class="clear"
                        text="messages.open.forward_attachment"
                    />
                    <ActionButton
                        @click="onActionClick('forward_new')"
                        icon=''
                        class="clear"
                        text='messages.open.forward_new'
                      />
                </template>
            </DropdownList>
        </div>
    </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  import ActionButton    from '@/vue/Elements/Buttons/ActionButton.vue';
  import DropdownList    from '@/vue/Elements/DropDowns/DropdownList.vue';

  const props = defineProps({
    webmail_view : {},
    message      : {},
    folder_id    : {}
  })


  const onActionClick = (action) => {
    props.webmail_view.routeTo('/compose', {
      action : action,
      mbox   : props.folder_id,
      uid    : props.message.id,
    })
  }

</script>
